// Copyright © 2021 Move Closer

import { SizeRegistry, SizeMap } from '../../_composables'

/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
export const bootstrapInputSizeRegistry: Partial<SizeRegistry> = {
  [SizeMap.Medium]: '--medium',
  [SizeMap.Large]: '--large'
}
